// import bookmark from "../../../assets/images/bookmark.svg";
import Brand from "../../../Json/Brand.json";
import Conditions from "../../../Json/Conditions.json";
import Size from "../../../Json/Size.json";
import { useSelector } from "react-redux";
import { Currency } from "../../Products/ProductsDetails";
import Emirates from "../../../Json/Emirats.json";
import palceholderimage from "../../../assets/images/palceholderimage.webp";
import {
  convertGlobalPrice,
  addRecentlyViewProduct,
  toggleLikeProduct,
  convertGlobalPriceBuyerServiceFee,
} from "../../../utils/firebase/firebase.utils";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DownloadModal from "../../Modals/DownloadModal";
import Map from "../../../assets/images/Map.png";
import { useTranslation } from "react-i18next";
import { Navigation } from "../../../utils/navigation/navigation";
import { LazyLoadImage } from "react-lazy-load-image-component";
import trusted from "../../../assets/images/trustedseller.svg";
import Countries from "../../../Json/Countries.json";
import PreviewImage from "./PreviewImage";
import SignIn from "../../SignIn/SignIn";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import libastrusted from "../../../assets/images/libasbadge.svg";
function ProductCard({
  card,
  currentUser,
  isFlash,
  // setShowSignin,
  card3,
  alteid,
}) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { currencies, selectedcurrency, currencydefault, countryCode } =
    useSelector((store) => store.currency);
  const { users } = useSelector((store) => store.allproducts);
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);
  const { details } = useSelector((store) => store.allproducts);
  const [show, setShow] = useState(false);
  const [isLiking, setIsLiking] = useState(false);
  const { flags } = useSelector((store) => store.flags);
  const [like, setLike] = useState(false);
  const [likeNum, setLikeNum] = useState(card?.userLikes?.length);

  // For opening signin/sign up modals for not login users
  const [showSignin, setShowSignin] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [forgetpassword, setForgetpassword] = useState(false);

  const handelOnCardPress = async (productId) => {
    if (currentUser) {
      await addRecentlyViewProduct(productId, currentUser.uid);
    }
    Navigation(navigate, `/product/${productId}`);
  };
  const isMobile = width <= 768;
  useEffect(() => {
    if (card) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [card]);

  function toggleLike() {
    setLike(!like);
    if (currentUser) {
      if (like) {
        if (card?.userLikes?.includes(currentUser.uid)) {
          setLikeNum(card?.userLikes?.length - 1);
        } else {
          setLikeNum(card?.userLikes?.length);
        }
      } else {
        if (card?.userLikes?.includes(currentUser.uid)) {
          setLikeNum(card?.userLikes?.length);
        } else {
          setLikeNum(card?.userLikes?.length + 1);
        }
      }
    }
  }
  useEffect(() => {
    if (currentUser != null) {
      if (card?.userLikes) {
        if (card?.userLikes?.includes(currentUser?.uid)) {
          setLike(true);
        } else {
          setLike(false);
        }
      }
    }
  }, [currentUser]);
  const handleSave = async (id) => {
    if (isMobile) {
      window.location.assign("https://libas.page.link/welcome");
      //navigator("https://libas.page.link/cart");
    } else {
      setShow(true);
    }
  };

  if (!currencies) {
    return;
  } else {
    if (currencies?.length === 0) return;
  }

  // new implementation of currency conversion
  // Determine currency display name based on language
  const getCurrencyName = (currencyId) => {
    const currency = currencies.find((c) => c.id === currencyId);
    return i18n.language === "en" ? currency.name : currency.nameAr;
  };

  // Calculate prices
  console.log(details, "details");
  const selectedCurrencyId = selectedcurrency || currencydefault;
  const pricingDetails = card
    ? convertGlobalPriceBuyerServiceFee(
        card?.idCurrency,
        card?.discountedPrice ? card?.discountedPrice : card?.price,
        selectedCurrencyId,
        currencies,
        countryCode
      )
    : { originalPrice: 0, buyerServiceFee: 0, totalPrice: 0 };
  return (
    card && (
      <>
        {showSignin && (
          <SignIn
            signIn={showSignin}
            handleSignIn={setShowSignin}
            handleSignUp={setSignUp}
            handleForgetpassword={setForgetpassword}
          />
        )}
        <div className=" show-modal-download">
          {show && <DownloadModal show={show} setShow={setShow} />}
        </div>
        <div
          className={`text-decoration w-100 pb-md-0 pb-2 mt-md-4 mb-md-4 ${
            i18n.language == "en"
              ? `pe-md-4 pe-3 ms-1 px-0`
              : `ps-md-4 ps-3 me-1 px-0`
          }`}
          key={card?.id}
        >
          <div
            className={` card ${card3 == "card3" ? `card3` : `card-order`}  `}
            key={card.id}
            style={{
              direction: i18n.language === "en" ? "ltr" : "rtl",
            }}
          >
            <div className="row text-center">
              <div className="col-12 position-relative px-0">
                <div
                  className="card-image"
                  onClick={() => handelOnCardPress(card?.id)}
                >
                  <a
                    href={`/product/${card?.id}`}
                    className="card-link-wrapper"
                    style={{ textDecoration: "none", color: "inherit" }}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default navigation
                      handelOnCardPress(card?.id);
                    }}
                  >
                    <LazyLoadImage
                      alt={alteid == null ? card.nameModel : alteid}
                      delayTime={300}
                      src={card.frontImage}
                      className={` product-img ${
                        card.status != "Pending" &&
                        card.status != "Live" &&
                        card.status != "Rejected"
                          ? `soldimgcolor`
                          : ""
                      }`}
                      placeholderSrc={palceholderimage}
                      loading="lazy"
                      style={{
                        objectFit: "contain",
                      }}
                    />
                  </a>
                </div>
                {users
                  ?.filter((user) => user?.id === card?.idUser)
                  ?.map((user) => {
                    return user?.userStatus === "Trusted" ||
                      user?.username === "wecurate." ||
                      user?.username === "madisonpassionluxe" ||
                      user?.username === "thereworkedplace" ||
                      user?.username === "gemaeeeofficial" ? (
                      <div
                        className={`position-absolute icons-trusted d-flex ${
                          i18n.language === "en" ? "start-0" : "end-0"
                        }`}
                        style={{
                          gap: "2px",
                        }}
                      >
                        <div
                          style={{
                            marginRight:
                              i18n.language === "en" ? "auto" : "22px",
                            marginLeft:
                              i18n.language === "en" ? "auto" : "13px",
                          }}
                        >
                          <img
                            src={
                              user?.username === "libas" ||
                              user?.username === "luxhype" ||
                              user?.userStatus === "LIBAS"
                                ? libastrusted
                                : trusted
                            }
                            alt="trusted"
                            className="trustedicon"
                            style={{
                              position: "relative",
                              bottom: "9px",
                            }}
                          />
                        </div>
                        <p
                          className="trusted-seller-badge-text"
                          style={{
                            fontSize: "16px",
                            color: "#C6AC96",
                          }}
                        >
                          {user?.username === "libas" ||
                          user?.username === "luxhype" ||
                          user?.userStatus === "LIBAS"
                            ? i18n.language === "ar"
                              ? "بوتيك"
                              : "Boutique"
                            : i18n.language === "ar"
                            ? "بائع موثوق"
                            : "Trusted Seller"}
                        </p>
                      </div>
                    ) : null;
                  })}

                {/* Heart & Like Count */}
                <div
                  role="button"
                  className={`position-absolute top-0 ${
                    i18n.language === "en" ? "end-0" : "start-0"
                  } p-2 d-flex align-items-end`}
                  style={{
                    fontSize: "16px",
                    color: like ? "#C6AC96" : "#777",
                    direction: i18n.language === "en" ? "ltr" : "rtl",
                    marginRight: i18n.language === "en" ? "17px" : "auto",
                    marginLeft: i18n.language === "en" ? "auto" : "17px",
                  }}
                  onClick={() =>
                    toggleLikeProduct(
                      card,
                      currentUser?.uid,
                      setIsLiking,
                      isLiking,
                      window
                    ) & toggleLike()
                  }
                >
                  <span
                    className="me-1 d-flex align-items-end"
                    style={{ fontSize: "16px", color: "#777" }}
                  >
                    {likeNum != 0 ? (
                      <span
                        className="me-1 "
                        style={{
                          marginLeft: i18n.language === "en" ? "auto" : "3px",
                          position: "relative",
                          top: "3px",
                        }}
                      >
                        {likeNum}
                      </span>
                    ) : (
                      <span className="me-1 invisible">0</span>
                    )}
                  </span>
                  {like ? (
                    <FaHeart style={{ color: "#C6AC96" }} />
                  ) : (
                    <FaRegHeart style={{ color: "#8C8C8C" }} />
                  )}
                </div>
              </div>
            </div>
            <div
              className="p-2 card-body card-body-product ps-md-4 ps-2 pt-md-3 pb-md-3 pt-1 pb-1"
              onClick={() => handelOnCardPress(card.id)}
            >
              {card.status != "Pending" &&
              card.status != "Live" &&
              card.status != "Rejected" ? (
                <>
                  <div className="SOLD ">{t("SOLD")}</div>
                </>
              ) : null}

              <div
                className="title2-product"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "99%",
                  textTransform: "uppercase",
                }}
              >
                {i18n.language === "en" ? (
                  card.nameBrand
                ) : Brand.filter((brand) => brand.name === card.nameBrand)
                    ?.length !== 0 ? (
                  Brand.filter((brand) => brand.name === card.nameBrand).map(
                    (brand) => <span key={brand.id}>{brand.nameAr}</span>
                  )
                ) : (
                  // Invisible fallback placeholder
                  <span style={{ visibility: "hidden" }}>Brand</span>
                )}
              </div>

              <div className="title3-product px-md-0">
                {card.nameModel ? (
                  card.nameModel
                ) : (
                  <span style={{ visibility: "hidden" }}>model</span>
                )}
              </div>

              <div
                className="title4-card "
                style={{
                  marginTop: card.discountedPrice ? "5px" : "0px",
                  marginBottom: card.discountedPrice ? "6px" : "1px",
                }}
              >
                {/* <Currency
                  isFlash={isFlash}
                  data={flags}
                  price={
                    currencies == null || currencies == undefined
                      ? null
                      : currencies?.length == 0
                      ? null
                      : convertGlobalPrice(
                          card.idCurrency,
                          card.price,
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies,
                          countryCode
                        )
                  }
                  dealPrice={
                    !card.dealPrice
                      ? null
                      : convertGlobalPrice(
                          card.idCurrency,
                          card.dealPrice,
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies,
                          countryCode
                        )
                  }
                  discountedPrice={
                    !card.discountedPrice
                      ? null
                      : convertGlobalPrice(
                          card.idCurrency,
                          card.discountedPrice,
                          !selectedcurrency
                            ? currencydefault
                            : selectedcurrency,
                          currencies,
                          countryCode
                        )
                  }
                  card={card}
                  TypeCurrency={
                    currencies == null || currencies == undefined
                      ? null
                      : currencies?.length == 0
                      ? null
                      : !selectedcurrency
                      ? i18n.language == "en"
                        ? currencies == null || currencies == undefined
                          ? null
                          : currencies?.filter(
                              (currency) => currency?.id === currencydefault
                            )[0].name
                        : currencies?.filter(
                            (currency) => currency?.id === currencydefault
                          )[0]?.nameAr
                      : i18n.language == "en"
                      ? currencies == null || currencies == undefined
                        ? null
                        : currencies?.filter(
                            (currency) => currency?.id === selectedcurrency
                          )[0]?.name
                      : currencies?.filter(
                          (currency) => currency?.id === selectedcurrency
                        )[0]?.nameAr
                  }
                /> */}
                {/* hell */}
                <Currency
                  isFlash={isFlash}
                  data={data}
                  dealPrice={{}}
                  buyerServiceFee="true"
                  price={pricingDetails?.totalPrice}
                  TypeCurrency={getCurrencyName(selectedCurrencyId)}
                  card={{}}
                />
              </div>
              {/* for size */}
              <div className="title7-product px-md-0">
                {card?.idSize ? (
                  Size?.filter((name) => name?.id == card?.idSize)?.map(
                    (size) => {
                      {
                        /* for bags case only show sizes name */
                      }
                      if (size?.type === "BAG") {
                        return (
                          <div
                            key={size?.id}
                            // style={{
                            //   visibility: "hidden",
                            // }}
                          >
                            {size?.name}
                          </div>
                        );
                      } else if (size?.name !== "S-M-L") {
                        return (
                          <div key={size?.id}>
                            {/* dont show for kids the international name */}
                            {size?.idCategory === "zw8UHRzTK2qlgU8Y4cVc" &&
                            size?.type === "CLOTHES"
                              ? ""
                              : size?.name}{" "}
                            {size?.size}
                          </div>
                        );
                      } else {
                        return (
                          <div key={size?.id}>
                            {size?.size} {t("Iternational")}
                          </div>
                        );
                      }
                    }
                  )
                ) : (
                  // Show invisible text or placeholder
                  <div style={{ visibility: "hidden" }}>Placeholder</div>
                )}
              </div>

              <div className="title3-product px-md-0">
                {card?.idCondition ? (
                  Conditions?.filter(
                    (name) => name?.id === card?.idCondition
                  ).map((condition) =>
                    i18n.language === "en" ? (
                      <div key={condition?.id}>{condition?.name}</div>
                    ) : (
                      <div key={condition?.id}>{condition?.nameAr}</div>
                    )
                  )
                ) : (
                  // Invisible placeholder to preserve layout
                  <div style={{ visibility: "hidden" }}>Placeholder</div>
                )}
              </div>
              {/* old code location */}
              {/* <div className="title6-product-unsold  d-flex  align-items-center ">
                <div>
                  <img
                    src={Map}
                    alt="pin"
                    className={`pin  ${
                      i18n.language == "en" ? `me-1` : `mx-1`
                    }`}
                  />
                </div>
                {Countries.filter(
                  (coun) => coun.nameEn === card.city?.trim()
                ).map((coun) =>
                  i18n.language === "en" ? coun.nameEn : coun.nameAr
                )}
              </div> */}
              {/* location new code */}
              <div className="title6-product-unsold d-flex align-items-center">
                <div>
                  <img
                    src={Map}
                    alt="pin"
                    className={`pin ${
                      i18n.language === "en" ? `me-1` : `mx-1`
                    }`}
                  />
                </div>
                <p
                  style={{
                    margin: 0,
                    position: "relative",
                    top: "0.5px",
                  }}
                >
                  {Emirates?.find(
                    (emirate) => emirate?.name === card?.city?.trim()
                  )
                    ? // If it's an Emirates city
                      i18n.language === "ar"
                      ? `${
                          Emirates.find(
                            (emirate) => emirate?.name === card?.city?.trim()
                          )?.nameAr
                        }, الإمارات`
                      : `${
                          Emirates.find(
                            (emirate) => emirate?.name === card?.city?.trim()
                          )?.name
                        }, UAE`
                    : // Else get from Countries list
                    i18n.language === "ar"
                    ? Countries?.find(
                        (coun) => coun?.nameEn === card?.city?.trim()
                      )?.nameAr || card?.city
                    : card?.city}
                </p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
}

export default ProductCard;
